module.exports = __webpack_public_path__ + "media/images/banners/bg1-10a48d1d697eb4be2a48f1440e1e8f13.png";